import { Dispatch } from 'react-redux';
import * as types from "./action-types";
import { AuthActionCreators, IApplicationState } from '../../index';
import { IEmailModel, IEmailModelListResponse } from "../../../models/index";
import { IEmailModelTemplateVariablesResponse } from '../../../models/index';
import { IEmailEngineVariableKeysResponse } from '../../../models/index';

//import { IPost } from '../../authorization';
//import { Utility } from '../../../services/utility';

export const ActionCreators = {
    getEmailModel: () => (dispatch: Dispatch<IApplicationState>): Promise<IEmailModelListResponse> => {
        var options = {
            url: __API__ + "/email-model"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IEmailModelListResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setEmailModels(response.data.results));

            return Promise.resolve(response);
        });
    },
    getEmailModelTemplateVariables: (emailModelId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailModelTemplateVariablesResponse> => {
        var options = {
            url: __API__ + "/email-model/" + emailModelId + "/template-variables"
        };
        return dispatch(AuthActionCreators.apiGet(options)).then((response: IEmailModelTemplateVariablesResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setEmailModelTemplateVariables(response.data.results));

            return Promise.resolve(response);
        });
    },
    getEmailEngineVariableKeys: () => (dispatch: Dispatch<IApplicationState>): Promise<IEmailEngineVariableKeysResponse> => {
        var options = {
            url: __API__ + "/email-model/variable-keys"
        };
        return dispatch(AuthActionCreators.apiGet(options)).then((response: IEmailEngineVariableKeysResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setEmailEngineVariableKeys(response.data.results));

            return Promise.resolve(response);
        });
    },
    setEmailModels: (list: IEmailModel[]) => {
        return {
            type: types.SET_EMAILMODELS,
            list
        }
    },
    setEmailModelTemplateVariables: (list: string[]) => {
        return {
            type: types.SET_EMAILMODELTEMPLATEVARIABLES,
            list
        }
    },
    setEmailEngineVariableKeys: (list: string[]) => {
        return {
            type: types.SET_EMAILENGINEVARIABLEKEYS,
            list
        }
    }

}